import Vue from 'vue'
import App from '@/main'
import Router from 'vue-router'
import Home from '@/views/Home'
import Joinery from '@/views/Joinery'
import Furniture from '@/views/Furniture'
import Single from '@/views/furniture/Single'
import About from '@/views/About'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        includeInMenu: false,
        showTitle: false
      }
    },
    {
      path: '/furniture',
      name: 'Furniture',
      component: Furniture,
      meta: {
        includeInMenu: true,
        showTitle: true
      }
    },
    {
      path: '/furniture/:slug',
      name: 'Furniture',
      component: Single,
      meta: {
        includeInMenu: false,
        showTitle: false
      }
    },
    {
      path: '/joinery',
      name: 'Joinery',
      component: Joinery,
      meta: {
        includeInMenu: true,
        showTitle: true
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        includeInMenu: true,
        showTitle: false
      }
    }
    // {
    //   path: '/shop',
    //   name: 'Shop',
    //   component: Home,
    //   meta: {
    //     includeInMenu: true,
    //   }
    // }
  ]
})

export default router
